<template>
  <div class="modal_wrapper" v-show="show">
    <div class="modal" :style="css">
      <div class="modal_body" >
        <slot></slot>
        <div class="title" v-if="title">
          <!--  @slot 匿名插槽 标题 -->
          <slot name="title">
            {{ title }}
          </slot>
        </div>
        <div class="desc" v-if="desc">
          <!--  @slot 具名插槽 内容描述-->
          <slot name="desc">{{ desc }}</slot>
        </div>
      </div>
      <div class="modal_footer" v-if="footer">
        <!--  @slot 具名插槽 底部按钮-->
        <slot name="footer">
          <div class="btn-list">
            <div class="cancel-btn" @click="close">{{ cancelText }}</div>
            <div class="confirm-btn" @click="confirm">{{ okText }}</div>
          </div>
        </slot>
      </div>
    </div>
    <div class="close-btn" v-if="showClose">
      <slot name="close_btn">
        <span class="icon-icon_close_30" @click="close"></span>
      </slot>
    </div>
  </div>
</template>

<script>
/**
 * 弹窗
 * @displayName cm-modal
 */
export default {
  name: 'CmModal',
  model: {
    prop: 'visible',
    event: 'toggle'
  },
  props: {
    /**
     * 控制显示隐藏
     * @model
     */

    visible: {
      type: Boolean,
      default: false
    },
    /**
     * 标题
     *
     */

    title: {
      type: String,
      default: ''
    },
    /** 内容描述 */

    desc: {
      type: String,
      default: ''
    },
    /** 取消文案 */

    cancelText: {
      type: String,
      default: '取消'
    },
    /** 确定文案 */

    okText: {
      type: String,
      default: '确定'
    },
    footer: {
      type: Boolean,
      default: true
    },
    showClose: {
      type: Boolean,
      default: false
    },
    css: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      show: false,
      params: null
    }
  },
  created () {
    this.show = this.visible
  },
  methods: {
    showModal (params) {
      this.show = true
      this.params = params
    },
    hide () {
      this.close()
    },
    close () {
      /**
       * 点击取消关闭按钮
       * @event toggle
       *
       * @property {boolean}
       */
      this.$emit('toggle', false)
      this.show = false
      this.params = null
    },
    confirm () {
      /**
       * 点击确定按钮
       * @event confirm
       *
       */
      this.$emit('confirm', this.params)
      this.show = false
    }
  },
  watch: {
    visible (val) {
      this.show = val
    }
  }
}
</script>

<style lang="less" scoped>
// 文字色
@color_text_6_1: #000000;
@color_text_6_2: #333333;
@color_text_6_3: #666666;
@color_text_6_4: #999999;
@color_text_6_5: #dbdbdb;
@color_text_6_6: #ffffff;
@color_text_6_7: #5a97c1;

// 分割线
@color_line_7_1: #e5e5e5;
@color_line_7_2: #f2f2f2;

.modal_wrapper {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 999;
  .close-btn {
    position: relative;
    margin-top: 0.48rem;
    font-size: 0.6rem;
    color: #fff;
    span {
      font-size: 0.6rem;
    }
  }
  .modal {
    border-radius: 0.48rem;
    position: relative;
    overflow: hidden;
     width: 5.6rem;
    .modal_body {
      width: 100%;
      background-color: #fff;
      box-sizing: border-box;

      min-height: 2.6rem;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img {
        display: block;
        width: 100%;
        height: auto;
      }
      .title {
        font-size: 0.32rem;
        color: @color_text_6_2;
        font-weight: bold;
        line-height: 0.48rem;
        padding: 0 0.48rem;
      }
      .desc {
        font-size: 0.28rem;
        color: @color_text_6_4;
        font-weight: bold;
        line-height: 0.42rem;
        margin-top: 0.3rem;
      }
      .step-modal {
        width: 100%;
        padding: 0.32rem 0 0.2rem;
        .title {
          display: block;
          font-size: 0.28rem;
          margin-bottom: 0.3rem;
        }
        .content {
          display: flex;
          justify-content: space-between;
          padding: 0 0.88rem 0.3rem;
          span {
            display: flex;
            width: 1.84rem;
            height: 1.84rem;
            border-radius: 50%;
            text-align: center;
            background-color: #f2f5f7;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            margin-bottom: 0.24rem;
            svg {
              width: 0.8rem;
              height: 0.8rem;
            }
          }
        }
      }
    }
    .modal_footer {
      border-top: 1px solid @color_line_7_1;
      background-color: #fff;
      .btn-list {
        display: flex;
        font-size: 0.32rem;

        align-items: center;
        .cancel-btn {
          flex: 1;
          color: @color_text_6_4;
          height: 1rem;
          line-height: 1rem;
          cursor: pointer;
          text-align: center;
        }
        .confirm-btn {
          flex: 1;
          color: @primary-color;
          border-left: 1px solid @color_line_7_1;
          height: 1rem;
          line-height: 1rem;
          cursor: pointer;
          text-align: center;
        }
      }
    }
  }
}
</style>
